export var BORDER_RADIUS = {
  small: '4px',
  medium: '8px',
  large: '16px',
  xLarge: 'TBD'
};